import * as Yup from "yup";
import { CompanyPolicyStatus } from "../helper/constants";

const MIN_TITLE_LENGTH: number = 3;
export const MAX_TITLE_LENGTH: number = 50;
const MIN_TASK_LENGTH: number = 1;
const MAX_TASK_LENGTH: number = 10;

export const AddCompayPolicyValidator = Yup.object({
  name: Yup.string()
    .required("Name is Required")
    .min(
      MIN_TITLE_LENGTH, 
      `Name must be at least ${MIN_TITLE_LENGTH} characters long`
    )
    .max(
      MAX_TITLE_LENGTH, 
      `Name must be less than ${MAX_TITLE_LENGTH} characters long`
    ),
  tags: Yup.array()
    .required("tags are required")
    .min(MIN_TASK_LENGTH, `Please select atleast ${MIN_TASK_LENGTH} tag`)
    .max(MAX_TASK_LENGTH, `Tags must not exceed ${MAX_TASK_LENGTH} tags`),
  status: Yup.number()
    .required("Status is required")
    .test(
      "is_status_valid",
      "Status is invalid",
      function (value) {
        const validStatuses = Object.values(CompanyPolicyStatus);
        return validStatuses.includes(Number(value));
      }
    )
    ,
  file: Yup.mixed<File>()
    .test(
      "is_file_allowed",
      "File must be a valid document, text or pdf", 
      function (value) {
        if (!value) return true;
        let fileName = value.name.toLowerCase();

        const validExtensions = [".pdf", ".docx", ".txt"];
        // Check if the file has a valid extension
        const isValid = validExtensions.some(extension => fileName.endsWith(extension));
        return isValid;
      }
    ),
});
